import { FeatureFlag } from '../FeatureFlag';

export const useTradingGateway = new FeatureFlag({
    key: 'use-trading-gateway',
    createdOn: '2026-09-22',
    defaultValue: false,
});
